import { CommonModule } from '@angular/common';
import { Component, computed, input } from '@angular/core';
import { ReportFields } from '../../../models/api/reports/report-fields';
import { BaseComponent } from '../../base/base.component';
import { ColumnComponent } from '../../core/table/column.component';
import { TableComponent } from '../../core/table/table.component';

@Component({
  selector: 'app-report-field-view',
  imports: [CommonModule, TableComponent, ColumnComponent],
  template: `
    <!-- Single section display (no fieldset needed) -->
    @if (!hasMultipleSections()) {
      <app-table
        [dataSource]="reportFields()"
        recordLabel="field"
        scrollHeight="360px"
        [stripedRows]="true"
        [showFilter]="true"
        [showFilterButton]="true"
        [showPaginator]="false"
      >
        <app-column name="sequence" label="Position" />
        <app-column name="reportField" label="Field" />
      </app-table>
    }

    <!-- Multiple sections display (with fieldsets) - matches old app behavior -->
    <!-- Each section shows ALL fields when displayed -->
    @if (hasMultipleSections()) {
      <!-- Fields in Report Section -->
      <fieldset class="tw-border tw-border-gray-300 tw-rounded tw-p-4 tw-mb-4">
        <legend class="tw-text-base tw-font-semibold tw-px-2">
          Fields in Report
        </legend>
        <app-table
          [dataSource]="reportFields()"
          recordLabel="field"
          scrollHeight="360px"
          [stripedRows]="true"
          [showFilter]="true"
          [showFilterButton]="true"
          [showPaginator]="false"
        >
          <app-column name="sequence" label="Position" />
          <app-column name="reportField" label="Field" />
        </app-table>
      </fieldset>

      <!-- Workers' Compensation Only Section -->
      @if (hasWcFields()) {
        <fieldset
          class="tw-border tw-border-gray-300 tw-rounded tw-p-4 tw-mb-4"
        >
          <legend class="tw-text-sm tw-font-semibold tw-px-2">
            Workers' Compensation Only
          </legend>
          <app-table
            [dataSource]="reportFields()"
            recordLabel="field"
            scrollHeight="360px"
            [stripedRows]="true"
            [showFilter]="true"
            [showFilterButton]="true"
            [showPaginator]="false"
          >
            <app-column name="sequence" label="Position" />
            <app-column name="reportField" label="Field" />
          </app-table>
        </fieldset>
      }

      <!-- Liability Only Section -->
      @if (hasLiFields()) {
        <fieldset
          class="tw-border tw-border-gray-300 tw-rounded tw-p-4 tw-mb-4"
        >
          <legend class="tw-text-sm tw-font-semibold tw-px-2">
            Liability Only
          </legend>
          <app-table
            [dataSource]="reportFields()"
            recordLabel="field"
            scrollHeight="360px"
            [stripedRows]="true"
            [showFilter]="true"
            [showFilterButton]="true"
            [showPaginator]="false"
          >
            <app-column name="sequence" label="Position" />
            <app-column name="reportField" label="Field" />
          </app-table>
        </fieldset>
      }
    }
  `,
  styles: ``,
})
export class ReportFieldViewComponent extends BaseComponent {
  reportFields = input<ReportFields[]>([]);

  // Check if WC or LI fields exist (determines if section should appear)
  hasWcFields = computed(() =>
    this.reportFields().some((f) => f.customSection === 'WC'),
  );

  hasLiFields = computed(() =>
    this.reportFields().some((f) => f.customSection === 'LI'),
  );

  // Check if there are multiple sections (WC or LI fields exist)
  hasMultipleSections = computed(
    () => this.hasWcFields() || this.hasLiFields(),
  );
}
